import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import Standards from "./sections/Standards";
import VeltStandard from "./sections/VeltStandard";
import Expertise from "./sections/Expertise";
import Alignment from "./sections/Alignment";
import Perspectives from "./sections/Perspectives";
import Partnership from "./sections/Partnership";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <Standards />
      <VeltStandard />
      <Expertise />
      <Alignment />
      <Perspectives />
      <Partnership />
      <Footer />
    </div>;
}